var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "gantt-elastic__main-view",
      style: { ..._vm.root.style["main-view"] },
    },
    [
      _c(
        "div",
        {
          staticClass: "gantt-elastic__main-container-wrapper",
          style: {
            ..._vm.root.style["main-container-wrapper"],
            height: _vm.root.state.options.height - _vm.hiddenRowsHeight + "px",
          },
        },
        [
          _c(
            "div",
            {
              ref: "mainView",
              staticClass: "gantt-elastic__main-container",
              style: {
                ..._vm.root.style["main-container"],
                width: _vm.root.state.options.clientWidth + "px",
                height:
                  _vm.root.state.options.height - _vm.hiddenRowsHeight + "px",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "gantt-elastic__container",
                  style: { ..._vm.root.style["container"] },
                  on: { mousemove: _vm.mouseMove, mouseup: _vm.mouseUp },
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.root.state.options.taskList.display,
                          expression: "root.state.options.taskList.display",
                        },
                      ],
                      ref: "taskList",
                      staticClass: "gantt-elastic__task-list-container",
                      style: {
                        ..._vm.root.style["task-list-container"],
                        /* 这个宽度会导致图形空白（x轴缩放时） */
                        // width: root.state.options.taskList.finalWidth + 'px',
                        height:
                          _vm.root.state.options.height -
                          _vm.hiddenRowsHeight +
                          "px",
                      },
                    },
                    [_c("task-list")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "chartContainer",
                      staticClass: "gantt-elastic__main-view-container",
                      style: { ..._vm.root.style["main-view-container"] },
                      on: {
                        mousedown: _vm.chartMouseDown,
                        touchstart: _vm.chartMouseDown,
                        mouseup: _vm.chartMouseUp,
                        touchend: _vm.chartMouseUp,
                        mousemove: function ($event) {
                          $event.preventDefault()
                          return _vm.chartMouseMove.apply(null, arguments)
                        },
                        touchmove: function ($event) {
                          $event.preventDefault()
                          return _vm.chartMouseMove.apply(null, arguments)
                        },
                        wheel: function ($event) {
                          $event.preventDefault()
                          return _vm.chartWheel.apply(null, arguments)
                        },
                      },
                    },
                    [_c("chart")],
                    1
                  ),
                  _vm._v(" "),
                  _vm.fixedCols.length
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.root.state.options.taskList.display,
                              expression: "root.state.options.taskList.display",
                            },
                          ],
                          ref: "taskList",
                          staticClass: "gantt-elastic__task-list-container",
                          style: {
                            ..._vm.root.style["task-list-container"],
                            width: _vm.getFixedWidth,
                            height:
                              _vm.root.state.options.height -
                              _vm.hiddenRowsHeight +
                              "px",
                          },
                        },
                        [_c("task-list-fixed")],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "chartScrollContainerVertical",
              staticClass:
                "gantt-elastic__chart-scroll-container gantt-elastic__chart-scroll-container--vertical",
              style: {
                ..._vm.root.style["chart-scroll-container"],
                ..._vm.root.style["chart-scroll-container--vertical"],
                ..._vm.verticalStyle,
              },
              on: { scroll: _vm.onVerticalScroll },
            },
            [
              _c("div", {
                staticClass: "gantt-elastic__chart-scroll--vertical",
                style: {
                  width: "1px",
                  height: _vm.root.state.options.allVisibleTasksHeight + "px",
                },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "chartScrollContainerHorizontal",
          staticClass:
            "gantt-elastic__chart-scroll-container gantt-elastic__chart-scroll-container--horizontal",
          style: {
            ..._vm.root.style["chart-scroll-container"],
            ..._vm.root.style["chart-scroll-container--horizontal"],
            marginLeft: _vm.getMarginLeft,
            marginRight: _vm.getMarginRight,
          },
          on: { scroll: _vm.onHorizontalScroll },
        },
        [
          _c("div", {
            staticClass: "gantt-elastic__chart-scroll--horizontal",
            style: {
              height: "1px",
              width: _vm.root.state.options.width + "px",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }